import type { AgentTurnCoverage } from '@avisoma/shared';
import { Badge } from '../../catalyst/badge';

const COVERAGE_META: Record<AgentTurnCoverage, { label: string; color: 'green' | 'amber' | 'red' | 'zinc' }> = {
  answered: { label: 'Answered', color: 'green' },
  partial: { label: 'Partial', color: 'amber' },
  no_data: { label: 'No data', color: 'red' },
  unknown: { label: 'Unknown', color: 'zinc' },
};

export default function CoverageBadge({ coverage }: { coverage: AgentTurnCoverage }) {
  const meta = COVERAGE_META[coverage] ?? COVERAGE_META.unknown;
  return (
    <Badge color={meta.color} className="whitespace-nowrap">
      {meta.label}
    </Badge>
  );
}
